import { twMerge } from 'tailwind-merge';
import PortalComponent from '../portal/Portal';

export function ModalComponent({
  children,
  handleHideModal,
  className = '',
}: {
  children: React.ReactNode;
  handleHideModal: () => void;
  className?: string;
}) {
  return (
    <PortalComponent selector="#modal">
      <div
        className={`fixed inset-0 z-50 flex items-center justify-center p-4`}
      >
        <div
          role="presentation"
          className="fixed inset-0 bg-background-overlay-light"
          onClick={handleHideModal}
        ></div>
        <div
          className={twMerge(
            'isolate max-h-full overflow-y-auto rounded-3xl bg-background-primary-light',
            className,
          )}
        >
          {children}
        </div>
      </div>
    </PortalComponent>
  );
}
